export type Language = 'en' | 'it';

let translations: Record<Language, any> | null = null;

export async function loadTranslations(): Promise<Record<Language, any>> {
  if (translations) return translations;
  
  const [enTranslations, itTranslations] = await Promise.all([
    import('@/translations/en.json').then(m => m.default),
    import('@/translations/it.json').then(m => m.default)
  ]);
  
  translations = {
    en: enTranslations,
    it: itTranslations
  };
  
  return translations;
}

export const defaultLanguage: Language = 'en';